export const getStartLanguage = () => {
    const originalLanguage = navigator.language;
    const newLanguage = originalLanguage.split('-')[0];
    const storedLanguage = localStorage.getItem("selectedLanguage");
    return storedLanguage ? storedLanguage : newLanguage;
};
  